import { useMutation, useQueryClient } from '@tanstack/react-query'

import { dataOrThrow, type PostPatientSubscriptionUpgradeBody } from '@snootsvet/shared'

import { useOsApi } from '@/frontend/hooks/api/use-os-api'

/**
 * Upgrades a patient's membership plan. The proration is charged off-session
 * against the member's saved card; when that fails Stripe holds the change and
 * leaves the invoice open for staff to send as a payment link.
 */
export function usePostPatientSubscriptionUpgrade(patientId: string) {
  const api = useOsApi()
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (body: PostPatientSubscriptionUpgradeBody) => {
      const response = await api.post('/patients/:patientId/subscription/upgrade', {
        params: { patientId },
        body,
      })
      return dataOrThrow(response)
    },
    onSuccess: () => {
      // Prefix-invalidates the upgrade preview too, which is keyed beneath this.
      queryClient.invalidateQueries({ queryKey: ['patient', patientId, 'subscription'] })
      queryClient.invalidateQueries({ queryKey: ['patient', patientId, 'invoices'] })
    },
  })
}
